module.exports = __webpack_public_path__ + "img/about-card-02.cb40499f.png";